'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _optionBoxLocal = require('./option-box.local.css');

var _optionBoxLocal2 = _interopRequireDefault(_optionBoxLocal);

var _icon = require('../../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Extensible on/off input for collecting boolean responses
 */


var OptionBox = function OptionBox(props) {
  var InputComponent = _react2.default.createElement('input', {
    key: 'input',
    className: _optionBoxLocal2.default.input,
    'data-auto': props.scope + '_' + props.name,
    disabled: props.disabled,
    id: props.id,
    name: props.name,
    onChange: props.onChange,
    checked: props.checked,
    type: props.type,
    value: props.value
  });

  return _react2.default.createElement('div', {
    role: props.role,
    className: (0, _classnames2.default)([_optionBoxLocal2.default.container, !props.showInput && _optionBoxLocal2.default.contentOnly, props.containerClassName])
  }, InputComponent, _react2.default.createElement('label', {
    htmlFor: props.id,
    className: (0, _classnames2.default)([_optionBoxLocal2.default.content, props.className])
  }, props.showInput && _react2.default.createElement('div', {
    className: (0, _classnames2.default)(_optionBoxLocal2.default.fauxbox, _optionBoxLocal2.default['fauxbox--' + props.type], _optionBoxLocal2.default[props.theme], props.inputClassName)
  }, props.type === 'radio' && props.theme === 'dark' ? _react2.default.createElement('div', {
    className: _optionBoxLocal2.default.radioDot
  }) : _react2.default.createElement(_icon2.default, {
    icon: 'check',
    color: props.theme === 'dark' ? 'dark' : 'light'
  })), props.icon && _react2.default.createElement(_icon2.default, {
    icon: props.icon,
    className: _optionBoxLocal2.default.icon
  }), props.children && _react2.default.createElement('span', {
    className: _optionBoxLocal2.default.label
  }, props.children)));
};

OptionBox.displayName = 'UIOptionBox';
OptionBox.defaultProps = {
  checked: false,
  children: null,
  className: null,
  containerClassName: null,
  disabled: false,
  label: '',
  icon: null,
  role: null,
  showInput: false,
  scope: 'input',
  value: '',
  theme: 'primary'
};
OptionBox.propTypes = {
  /**
   * Classname applied to parent container of custom-option-box
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Component classnames
   */
  className: _propTypes2.default.string,

  /**
   * Classname of input box
   */
  inputClassName: _propTypes2.default.string,

  /**
   * wrap children text to create a label
   */
  children: _propTypes2.default.any,

  /**
   * HTML disabled state
   */
  disabled: _propTypes2.default.bool,

  /**
   * Unique ID of input
   */
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,

  /**
   * Name of icon to become input toggle
   */
  icon: _propTypes2.default.string,

  /**
   * Name of singular input, or shared name of related inputs
   */
  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,

  /**
   * onChange handler
   */
  onChange: _propTypes2.default.func,

  /**
   * ARIA role designation
   */
  role: _propTypes2.default.string,

  /**
   * Define the context/scope of where this input is used
   */
  scope: _propTypes2.default.string,

  /**
   * Set whether input should be in checked state
   */
  checked: _propTypes2.default.bool,

  /**
   * Set whether a faux-input box should be shown
   */
  showInput: _propTypes2.default.bool,

  /**
   * Set whether this input is to be used as a radio or checkbox
   */
  type: _propTypes2.default.oneOf(['radio', 'checkbox']).isRequired,

  /**
   * Value of this input
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

  /**
   * Theme
   */
  theme: _propTypes2.default.oneOf(['classic', 'primary', 'dark'])
};
exports.default = OptionBox;